import formatTimingPrefix from "./formatTimingPrefix";

const VERIFY_CODE_SIGN_IN = "verifyCodeSignIn";

const sentryVerifyCodeSignIn = () => {
    const timingPrefix = formatTimingPrefix();
    const timeZero = sessionStorage.getItem(`${timingPrefix}timeZero`);

    const eventName = `${timingPrefix}${VERIFY_CODE_SIGN_IN}`;

    //user clicks verfiy code sign in button
    const verifyCodeSignInStartTime = performance.now();

    const verifyCodeSignInExists = sessionStorage.getItem(eventName);

    if (verifyCodeSignInExists) {
        // Remove old and set with new value
        sessionStorage.removeItem(eventName);
    }

    const verifyCodeSignInDelta = String(verifyCodeSignInStartTime - Number(timeZero));
    sessionStorage.setItem(eventName, verifyCodeSignInDelta);
};

export default sentryVerifyCodeSignIn;
